export default __webpack_public_path__ + "static/tripleLift-d732bc7443f7ed2443c8a93b66cca3b5.svg";